import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        ref: _ctx.setEl,
        id: "price-slider",
        class: "price-slider"
    }, null, 512 /* NEED_PATCH */));
}
